import { gql } from '__generated__';

export default gql(`
  mutation DeactivateProduct($id: ID!) {
    deactivateProduct(id: $id) {
      id
      active
    }
  }
`);
